export default "__VITE_ASSET__KyGegi89__"